import { render } from "./App.vue?vue&type=template&id=a55caca6"
const script = {}

import "./App.vue?vue&type=style&index=0&id=a55caca6&lang=scss"

import exportComponent from "C:\\Users\\y-sakakibara\\Documents\\Git\\workflow-system\\workflow\\frontend\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__